import stile from './Downloads.module.css';
import { useSprache } from '../sprache';

function Downloads() {
  const { sprache, t } = useSprache();

  // Liste aller verfuegbaren Nachweise, Zertifikate und Bewerbungsunterlagen. Nur der
  // Lebenslauf liegt in beiden Sprachen vor, die Zeugnisse und Zertifikate sind die Originale.
  const dokumente = [
    {
      name: { de: 'Lebenslauf', en: 'CV / Résumé' },
      datei: { de: 'Kalakutok_Wadim_Lebenslauf_DE.pdf', en: 'Kalakutok_Wadim_CV_EN.pdf' },
      typ: { de: 'PDF • Vollständiges Profil', en: 'PDF • Full profile' },
    },
    {
      name: { de: 'Full-Stack Zertifikat', en: 'Full-Stack Certificate' },
      datei: 'Zertifikat_Kalakutok_W.pdf',
      typ: { de: 'PDF • Web Development', en: 'PDF • Web Development' },
    },
    {
      name: { de: 'Arbeitszeugnis', en: 'Employment Reference' },
      datei: 'Kalakutok, Wadim Arbeitszeugnis.pdf',
      typ: { de: 'PDF • Referenzen & Praxis', en: 'PDF • References & Practice' },
    },
    {
      name: { de: 'Linux Zertifikat', en: 'Linux Certificate' },
      datei: 'Linux Zertifikat.pdf',
      typ: { de: 'PDF • System & Kernel', en: 'PDF • System & Kernel' },
    },
    {
      name: { de: 'Scrum Master (ASM)', en: 'Scrum Master (ASM)' },
      datei: 'Scrum Master.pdf',
      typ: { de: 'PDF • Agiles Management', en: 'PDF • Agile Management' },
    },
  ].map((dokument) => ({
    name: dokument.name[sprache],
    datei: typeof dokument.datei === 'string' ? dokument.datei : dokument.datei[sprache],
    typ: dokument.typ[sprache],
  }));

  return (
    <section className={`${stile.downloadsSection} scrollEnthuellung`} id="downloads">
      <span className="abschnittsNummer">[03] {t('nav.downloads')}</span>
      <h2 className={stile.mainTitle}>{t('downloads.titel')}</h2>
      <p className={stile.subTitle}>
        {t('downloads.untertitel')}
      </p>

      <div className={stile.documentsContainer}>
        {dokumente.map((dokument) => (
          <a
            key={dokument.datei}
            className={stile.dokumentKarte}
            href={`./documents/${dokument.datei}`}
            target="_blank"
            rel="noopener noreferrer"
            title={`${dokument.name} ${t('downloads.ansehen')}`}
          >
            <div className={stile.iconHuelle}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.14.375-.65 1.178-.99 2.052-1.042.34-.02.693-.01 1.05.03.498-.553.94-1.284 1.258-2.072-.452-.8-.748-1.637-.8-2.39-.06-.856.248-1.42.748-1.574.45-.138.905.074 1.135.534.225.45.18.995-.088 1.63-.263.626-.67 1.29-1.18 1.95 1.01.442 2.19.866 3.14.993.45.06.745.22.842.477.108.286.01.62-.25.864-.32.302-.79.378-1.257.205-.85-.316-1.78-.96-2.58-1.8-1.02.26-2.09.43-3.08.52-.35.48-.71.9-1.07 1.24-.48.45-.96.65-1.4.65a1.2 1.2 0 0 1-.36-.055"/>
              </svg>
            </div>

            <div className={stile.textContainer}>
              <span className={stile.dokumentTitel}>{dokument.name}</span>
              <span className={stile.dokumentFormat}>{dokument.typ}</span>
            </div>

            <div className={stile.pfeilIcon}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z"/>
              </svg>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

export default Downloads;
